import { MutationTree } from "vuex";
import {Area, VacancyArea, Store, StoreContract} from "throne-api";

import types from "@/store/types";

import { RootState } from "./state";
import { FacilityVacancy } from "vacancy";

export const mutations: MutationTree<RootState> = {
    [types.mutations.SET_STORE]: (state: RootState, store: Store) => {
        state.store = store;
    },
    [types.mutations.SET_STORE_CONTRACT]: (state: RootState, storeContract: StoreContract) => {
        state.storeContract = storeContract;
    },
    [types.mutations.SET_AREA_LIST]: (state: RootState, areaList: Area[]) => {
        state.areaList = areaList;
    },
    [types.mutations.SET_VACANCY_AREA_LIST]: (state: RootState, vacancyAreaList: VacancyArea[]) => {
        state.vacancyAreaList = vacancyAreaList;
    },
    [types.mutations.SET_FACILITY_VACANCY_LIST]: (state: RootState, facilityVacancyList: FacilityVacancy[]) => {
        state.facilityVacancyList = facilityVacancyList;
    },
};
